"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CategoryPeopleIcon = (props) => {
    return (react_1.default.createElement("svg", { className: props.size, viewBox: "0 0 24 24", fill: "none" },
        react_1.default.createElement("rect", { className: props.size, rx: "12", fill: "#BF8CFF" }),
        react_1.default.createElement("path", { d: "M12.5834 9.66668C12.5834 8.37751 11.5392 7.33334 10.25 7.33334C8.96087 7.33334 7.91671 8.37751 7.91671 9.66668C7.91671 10.9558 8.96087 12 10.25 12C11.5392 12 12.5834 10.9558 12.5834 9.66668ZM13.75 10.8333V12H15.5V13.75H16.6667V12H18.4167V10.8333H16.6667V9.08334H15.5V10.8333H13.75ZM5.58337 15.5V16.6667H14.9167V15.5C14.9167 13.9483 11.8075 13.1667 10.25 13.1667C8.69254 13.1667 5.58337 13.9483 5.58337 15.5Z", fill: "white" })));
};
exports.default = CategoryPeopleIcon;
